import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const firstRun = useRef(true);

  useEffect(() => {
    const isFirstRun = firstRun.current;
    firstRun.current = false;
    if (hash) {
      // Wait for the DOM to update, then scroll to the element
      // Use setTimeout to ensure React has finished rendering
      setTimeout(() => {
        const element = document.getElementById(hash.slice(1)); // Remove the '#' prefix
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else if (!isFirstRun) {
      // No hash - scroll to top. Skipped on first load: the browser already placed the
      // page, and a visitor may have scrolled the pre-built HTML before it hydrated.
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
